// src/components/NotFoundPage.jsx

import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>404 - Page Not Found</h1>
      <p style={styles.text}>The page you're looking for doesn't exist.</p>
      <Link to="/" style={styles.link}>Go back to Home</Link>
    </div>
  );
};

const styles = {
  container: {
    textAlign: 'center',
    marginTop: '100px',
    fontFamily: 'Arial, sans-serif',
  },
  heading: {
    fontSize: '48px',
    color: '#ff5555',
  },
  text: {
    fontSize: '20px',
    margin: '20px 0',
  },
  link: {
    fontSize: '18px',
    textDecoration: 'none',
    color: '#007bff',
  }
};

export default NotFoundPage;
